import { editorPicks } from '@/mocks/animeData';

export default function EditorPicks() {
  const [lead, ...rest] = editorPicks;

  return (
    <section id="editor" className="scroll-mt-20 px-4 py-12 md:px-6 md:py-16">
      <div className="mx-auto max-w-6xl">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              编辑推荐
            </h2>
            <p className="mt-1 text-sm text-foreground-600">
              编辑团队反复挑选的必追佳作，剧情与画风双重在线
            </p>
          </div>
          <span className="inline-flex items-center gap-1 rounded-full bg-primary-100 px-3 py-1 text-xs font-bold text-primary-700">
            <i className="ri-star-smile-fill"></i>
            本周精选
          </span>
        </div>

        <div className="grid grid-cols-1 gap-3 md:gap-4 lg:grid-cols-3">
          <article
            className="group relative cursor-pointer overflow-hidden rounded-lg lg:col-span-1 lg:row-span-2"
            data-product-shop
          >
            <img
              src={lead.image}
              alt={`${lead.title} 编辑推荐漫画封面`}
              title={`编辑力荐 ${lead.title}`}
              className="h-full min-h-[360px] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-background-950/20 to-transparent"></div>
            <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
              <span className="mb-2 inline-block rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">
                编辑力荐
              </span>
              <h3 className="font-heading text-xl text-background-50 md:text-2xl">{lead.title}</h3>
              <p className="mt-1 line-clamp-2 text-xs leading-5 text-background-100">{lead.desc}</p>
              <div className="mt-3 flex items-center gap-2">
                <span className="rounded-full bg-accent-500 px-2 py-0.5 text-xs font-medium text-background-50">
                  {lead.genre}
                </span>
                <span className="text-xs text-background-100">更新至 {lead.chapter}</span>
                <span className="ml-auto inline-flex items-center gap-1 text-sm font-bold text-secondary-400">
                  <i className="ri-star-fill"></i>
                  {lead.score}
                </span>
              </div>
            </div>
          </article>

          <div className="grid grid-cols-1 gap-3 md:gap-4 lg:col-span-2 sm:grid-cols-3">
            {rest.map((comic) => (
              <article
                key={comic.id}
                className="group flex cursor-pointer flex-col rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
                data-product-shop
              >
                <div className="relative w-full overflow-hidden rounded-md">
                  <img
                    src={comic.image}
                    alt={`${comic.title} 编辑推荐漫画封面`}
                    title={`编辑力荐 ${comic.title}`}
                    className="aspect-[3/4] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-2 top-2 rounded-full bg-background-950/70 px-2 py-1 text-xs font-bold text-secondary-400 backdrop-blur-sm">
                    <i className="ri-star-fill"></i> {comic.score}
                  </span>
                </div>
                <h3 className="mt-3 text-base font-bold text-foreground-950 group-hover:text-primary-700">
                  {comic.title}
                </h3>
                <p className="mt-1 line-clamp-2 flex-1 text-xs leading-5 text-foreground-600">
                  {comic.desc}
                </p>
                <div className="mt-3 flex items-center gap-2">
                  <span className="rounded-full bg-accent-100 px-2 py-0.5 text-xs font-medium text-accent-800">
                    {comic.genre}
                  </span>
                  <span className="ml-auto text-xs text-foreground-400">{comic.chapter}</span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}